import React, { useState } from 'react'
import store from '../reducer/store'
import { NavLink } from 'react-router-dom'
import '../css/menu.css'
// import Logo from '../components/svg/LogoPixart'
import Logo from '../img/logo-tfja.svg'
import iconMarker from '../img/icon_geofence.svg'
import { useTranslation } from 'react-i18next'

export default function Menu () {
  const { t } = useTranslation('menu')
  const { user } = store.getState()
  const [views, setViews] = useState({
    preferences: false,
    safeweb: false,
    events: false
  })

  const role = user.roles

  const showSubMenu = (data, views, set) => {
    const liPreferences = document.getElementById('list-item-preferences')
    const liSafeweb = document.getElementById('list-item-safeweb')
    const liEvents = document.getElementById('list-item-events')
    const array1 = document.querySelectorAll('.i-preferences')
    const array2 = document.querySelectorAll('.i-events')
    const subMenu = data
    if (subMenu === 'preferences') {
      if (views?.preferences) {
        array1?.forEach(element => {
          element.classList.remove('full-circle')
        })
      }

      set({
        preferences: !views?.preferences,
        safeweb: false,
        events: false
      })

      liPreferences.classList.toggle('menu-is-opening')
      liPreferences.classList.toggle('menu-open')

      if (liSafeweb) {
        liSafeweb.classList.remove('menu-is-opening')
        liSafeweb.classList.remove('menu-open')
      }

      if (liEvents) {
        liEvents.classList.remove('menu-is-opening')
        liEvents.classList.remove('menu-open')
      }
    } else if (subMenu === 'safeweb') {
      set({
        preferences: false,
        safeweb: !views?.safeweb,
        events: false
      })

      liSafeweb.classList.toggle('menu-is-opening')
      liSafeweb.classList.toggle('menu-open')

      if (liPreferences) {
        liPreferences.classList.remove('menu-is-opening')
        liPreferences.classList.remove('menu-open')
      }

      if (liEvents) {
        liEvents.classList.remove('menu-is-opening')
        liEvents.classList.remove('menu-open')
      }
    } else if (subMenu === 'events') {
      if (views?.events) {
        array2?.forEach(element => {
          element.classList.remove('full-circle')
        })
      }

      set({
        preferences: false,
        safeweb: false,
        events: !views?.events
      })

      liEvents.classList.toggle('menu-is-opening')
      liEvents.classList.toggle('menu-open')

      if (liPreferences) {
        liPreferences.classList.remove('menu-is-opening')
        liPreferences.classList.remove('menu-open')
      }

      if (liSafeweb) {
        liSafeweb.classList.remove('menu-is-opening')
        liSafeweb.classList.remove('menu-open')
      }
    }
  }

  const changeIcon = (view, id) => {
    let array
    if (view.preferences) {
      array = document.querySelectorAll('.i-preferences')
    } else if (view.events) {
      array = document.querySelectorAll('.i-events')
    }
    array.forEach(element => {
      if (element.id === id) {
        element.classList.add('full-circle')
      } else {
        element.classList.remove('full-circle')
      }
    })
  }

  const closeMenu = (section) => {
    const body = document.querySelector('body')
    const windowWidth = document.documentElement.clientWidth
    // console.log(windowWidth)
    if (windowWidth < 975) {
      body.className = 'sidebar-closed sidebar-collapse'
    }
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    })

    if (section !== 'preferences' && section !== 'safeweb' && section !== 'events') {
      setViews({
        preferences: false,
        safeweb: false,
        events: false
      })

      const liPreferences = document.getElementById('list-item-preferences')
      const liSafeweb = document.getElementById('list-item-safeweb')
      const liEvents = document.getElementById('list-item-events')
      const array1 = document.querySelectorAll('.i-preferences')
      const array2 = document.querySelectorAll('.i-events')

      liSafeweb?.classList.remove('menu-is-opening')
      liSafeweb?.classList.remove('menu-open')
      liPreferences?.classList.remove('menu-is-opening')
      liPreferences?.classList.remove('menu-open')
      liEvents?.classList.remove('menu-is-opening')
      liEvents?.classList.remove('menu-open')
      array1?.forEach(element => {
        element.classList.remove('full-circle')
      })
      array2?.forEach(element => {
        element.classList.remove('full-circle')
      })
    }
  }

  return (
    <aside className="main-sidebar sidebar-dark-primary elevation-4 containerAside">
      <NavLink to="/mdm/home" className="brand-link ">
        {/* <Logo className="mdm-logo"/> */}
        <img src={Logo} alt="logo" className="mdm-logo logo-clm"/>
      </NavLink>
      <div className="sidebar">
        <nav className="mt-2">
          <ul
            className="nav nav-pills nav-sidebar flex-column"
            data-widget="treeview"
            role="menu"
            data-accordion="false"
          >
            {Object.keys(role?.homePage).length !== 0 &&
            <li className="nav-item" onClick={() => closeMenu('home')}>
              <NavLink to="/mdm/home" className="nav-link hoverly" >
                <i className="fa-solid fa-house nav-icon"></i>
                <p className="colorLeters">{t('inicio')}</p>
              </NavLink>
            </li>}
            {Object.keys(role?.devicesPage).length !== 0 && <li className="nav-item" onClick={() => closeMenu('devices')}>
              <NavLink to="/mdm/devices" className="nav-link hoverly">
                <i className="fa-solid fa-tablet-screen-button nav-icon"></i>
                <p className="colorLeters">{t('dispositivos')}</p>
              </NavLink>
            </li>}
            { Object.keys(role?.groupsPage).length !== 0 && <li className="nav-item" onClick={() => closeMenu('groups')}>
              <NavLink to="/mdm/groups" className="nav-link hoverly">
                <i className="fas fa-users nav-icon"></i>
                <p className="colorLeters">{t('grupos')}</p>
              </NavLink>
            </li>}
            {Object.keys(role?.usersPage).length !== 0 && <li className="nav-item" onClick={() => closeMenu('users')}>
                <NavLink to="/mdm/users" className="nav-link hoverly">
                  <i
                    className="fas fa-user-friends nav-icon"
                    aria-hidden="true"
                  ></i>
                  <p className="colorLeters">{t('usuarios')}</p>
                </NavLink>
              </li>}
              {Object.keys(role?.establishmentsPage).length !== 0 && <li className="nav-item" onClick={() => closeMenu('establishments')}>
                <NavLink to="/mdm/establishments" className="nav-link hoverly">
                  <i
                    className="fas fa-building nav-icon"
                    aria-hidden="true"
                  ></i>
                  <p className="colorLeters">{t('establecimientos')}</p>
                </NavLink>
              </li>}
              {Object.keys(role?.rolesPage).length !== 0 && <li className="nav-item" onClick={() => closeMenu('roles')}>
                <NavLink to="/mdm/roles" className="nav-link hoverly">
                  <i
                    className="fas fa-user-tag nav-icon"
                    aria-hidden="true"
                  ></i>
                  <p className="colorLeters">{t('roles')}</p>
                </NavLink>
              </li>}
              {Object.keys(role?.geofencesPage).length !== 0 && <li className="nav-item" onClick={() => closeMenu('geofences')}>
                <NavLink to="/mdm/geofences" className="nav-link hoverly">
                  <img
                    src={iconMarker}
                    alt="map-marker"
                    style={{ margin: '0 0.25rem', width: '11%' }}
                  />
                  <p className="colorLeters">{t('geocercas')}</p>
                </NavLink>
              </li>}
              {Object.keys(role?.applicationsPage).length !== 0 && <li className="nav-item" onClick={() => closeMenu('applications')}>
                <NavLink to="/mdm/applications" className="nav-link hoverly">
                  <i
                    className="fa fa-solid fa-shapes nav-icon"
                    aria-hidden="true"
                  ></i>
                  <p className="colorLeters">{t('aplicaciones')}</p>
                </NavLink>
              </li>}
              {Object.keys(role?.reportsPage).length !== 0 && <li className="nav-item" onClick={() => closeMenu('reports')}>
                <NavLink to="/mdm/reports" className="nav-link hoverly">
                  <i
                    className="fa fa-solid fa-paste nav-icon"
                    aria-hidden="true"
                  ></i>
                  <p className="colorLeters">{t('reportes')}</p>
                </NavLink>
              </li>}
              {(Object.keys(role?.preferencesSettingsPage).length !== 0 || Object.keys(role?.preferencesReportsPage).length !== 0 ||
              Object.keys(role?.preferencesLossesPage).length !== 0 || Object.keys(role?.preferencesUseTimePage).length !== 0 ||
              Object.keys(role?.preferencesGeofencePage).length !== 0 || Object.keys(role?.preferencesRxartSecurePage).length !== 0 || Object.keys(role?.preferencesServerPage || Object.keys(role?.preferencesAgentPage)).length !== 0) &&

              <li className="nav-item dropdown" id='list-item-preferences'>
                <div
                  className="nav-link"
                  onClick={() => showSubMenu('preferences', views, setViews)}
                >
                  <i className="fas fa-cogs nav-icon "></i>
                  <p className="colorLeters">
                    {t('configuraciones')}
                    <i className="fas fa-angle-left float-right right" />
                  </p>
                </div>
                <ul
                  className={`nav nav-treeview ${views.preferences ? 'subMenu' : null}`}
                  // style={{
                  //   display: views.preferences ? 'block' : 'none'
                  // }}
                  id="preferences-submenu"
                >
                  {Object.keys(role?.preferencesSettingsPage).length !== 0 && <li className="nav-item" onClick={() => {
                    closeMenu('preferences')
                    changeIcon(views, 'i-conexiones')
                  }}>
                    <NavLink
                      to="/mdm/preferences/configs"
                      className="nav-link hoverly"
                    >
                      <i className="circle nav-icon i-preferences" id="i-conexiones"/>
                      <p className="colorLeters">{t('conexiones')}</p>
                    </NavLink>
                  </li>}
                  {Object.keys(role?.preferencesReportsPage).length !== 0 && <li className="nav-item" onClick={() => {
                    closeMenu('preferences')
                    changeIcon(views, 'i-reportes')
                  }}>
                    <NavLink
                      to="/mdm/preferences/reports"
                      className="nav-link hoverly"
                    >
                      <i className="circle nav-icon i-preferences" id="i-reportes"/>
                      <p className="colorLeters">{t('alertas')}</p>
                    </NavLink>
                  </li>}
                  {Object.keys(role?.preferencesLossesPage).length !== 0 && <li className="nav-item" onClick={() => {
                    closeMenu('preferences')
                    changeIcon(views, 'i-extravios')
                  }}>
                    <NavLink
                      to="/mdm/preferences/lost"
                      className="nav-link hoverly"
                    >
                      <i className="circle nav-icon i-preferences" id="i-extravios"/>
                      <p className="colorLeters">{t('extravios')}</p>
                    </NavLink>
                  </li>}
                  {Object.keys(role?.preferencesUseTimePage).length !== 0 && <li className="nav-item" onClick={() => {
                    closeMenu('preferences')
                    changeIcon(views, 'i-tiemposDeUso')
                  }}>
                        <NavLink
                          to="/mdm/preferences/usage-time"
                          className="nav-link hoverly"
                        >
                          <i className="circle nav-icon i-preferences" id="i-tiemposDeUso"/>
                          <p className="colorLeters">{t('tiempos de uso')}</p>
                        </NavLink>
                      </li>}
                      {Object.keys(role?.preferencesGeofencePage).length !== 0 && <li className="nav-item" onClick={() => {
                        closeMenu('preferences')
                        changeIcon(views, 'i-geocercas')
                      }}>
                        <NavLink
                          to="/mdm/preferences/geofence-notifications"
                          className="nav-link hoverly"
                        >
                          <i className="circle nav-icon i-preferences" id="i-geocercas"/>
                          <p className="colorLeters">{t('geocercas')}</p>
                        </NavLink>
                      </li>}
                      {Object.keys(role?.preferencesRxartSecurePage).length !== 0 && <li className="nav-item" onClick={() => {
                        closeMenu('preferences')
                        changeIcon(views, 'i-rxartSecure')
                      }}>
                        <NavLink
                          to="/mdm/preferences/rxart-secure"
                          className="nav-link hoverly"
                        >
                          <i className="circle nav-icon i-preferences" id="i-rxartSecure"/>
                          <p className="colorLeters">{t('rxart secure')}</p>
                        </NavLink>
                  </li>}
                      {Object.keys(role?.preferencesServerPage).length !== 0 && <li className="nav-item" onClick={() => {
                        closeMenu('preferences')
                        changeIcon(views, 'i-servidor')
                      }}>
                        <NavLink
                          to="/mdm/preferences/server"
                          className="nav-link hoverly"
                        >
                          <i className="circle nav-icon i-preferences" id="i-servidor"/>
                          <p className="colorLeters">Servidor</p>
                        </NavLink>
                      </li>}
                      {Object.keys(role?.preferencesAgentPage).length !== 0 && <li className="nav-item" onClick={() => {
                        closeMenu('preferences')
                        changeIcon(views, 'i-agente')
                      }}>
                        <NavLink
                          to="/mdm/agent-administration"
                          className="nav-link hoverly"
                        >
                          <i className="circle nav-icon i-preferences" id="i-agente"/>
                          <p className="colorLeters">{t('agente')}</p>
                        </NavLink>
                      </li>}
                </ul>
              </li>}
              {(Object.keys(role?.devicesEventsPage).length !== 0 || Object.keys(role?.softwareEventsPage).length !== 0) &&
              <li className="nav-item dropdown" id='list-item-events'>
                <div
                  className="nav-link"
                  onClick={() => showSubMenu('events', views, setViews)}
                >
                  <i className="fas fa-cogs nav-icon "></i>
                  <p className="colorLeters">
                    {t('eventos')}
                    <i className="fas fa-angle-left float-right right" />
                  </p>
                </div>
                <ul
                  className={`nav nav-treeview ${views.events ? 'subMenu' : null}`}
                  id="events-submenu"
                >
                  {Object.keys(role?.softwareEventsPage).length !== 0 && <li className="nav-item" onClick={() => {
                    closeMenu('events')
                    changeIcon(views, 'i-software')
                  }}>
                    <NavLink
                      to="/mdm/events/software-events"
                      className="nav-link hoverly"
                    >
                      <i className="circle nav-icon i-events" id="i-software"/>
                      <p className="colorLeters">{t('software')}</p>
                    </NavLink>
                  </li>}
                  {Object.keys(role?.devicesEventsPage).length !== 0 && <li className="nav-item" onClick={() => {
                    closeMenu('events')
                    changeIcon(views, 'i-devicesEvents')
                  }}>
                    <NavLink
                      to="/mdm/events/devices-events"
                      className="nav-link hoverly"
                    >
                      <i className="circle nav-icon i-events" id="i-devicesEvents"/>
                      <p className="colorLeters">{t('dispositivos')}</p>
                    </NavLink>
                  </li>}
                </ul>
              </li>}
            {/* (Object.keys(role?.safeWebHomePage).length !== 0 || Object.keys(role?.safeWebListsPage).length !== 0 ||
            Object.keys(role?.safeWebWordsPage).length !== 0 || Object.keys(role?.safeWebPreferencesPage).length !== 0) &&
            <li className="nav-item dropdown" id='list-item-safeweb'>
              <div
                className="nav-link"
                onClick={() => showSubMenu('safeweb', views, setViews)}
              >
                <i className="fa-solid fa-shield-halved nav-icon"></i>
                <p className="colorLeters">
                  Safeweb
                  <i className="fas fa-angle-left right float-right" />
                </p>
              </div>
              <ul
                className={`nav nav-treeview ${views.safeweb ? 'subMenu' : null}`}
                // style={{
                //   display: views.safeweb ? 'block' : 'none'
                // }}
                id="safeweb-submenu"
              >
                {Object.keys(role?.safeWebHomePage).length !== 0 && <li className="nav-item" onClick={() => closeMenu('safeweb')}>
                  <NavLink to="/mdm/safeweb" className="nav-link hoverly">
                    <i className="far fa-circle nav-icon" />
                    <p className="colorLeters">Inicio</p>
                  </NavLink>
                </li>}
                {Object.keys(role?.safeWebListsPage).length !== 0 && <li className="nav-item" onClick={() => closeMenu('safeweb')}>
                  <NavLink to="/mdm/lists" className="nav-link hoverly">
                    <i className="far fa-circle nav-icon" />
                    <p className="colorLeters">Listas</p>
                  </NavLink>
                </li>}
                {Object.keys(role?.safeWebWordsPage).length !== 0 && <li className="nav-item" onClick={() => closeMenu('safeweb')}>
                  <NavLink to="/mdm/words" className="nav-link hoverly">
                    <i className="far fa-circle nav-icon" />
                    <p className="colorLeters">Palabras claves</p>
                  </NavLink>
                </li>}
                {Object.keys(role?.safeWebPreferencesPage).length !== 0 && <li className="nav-item" onClick={() => closeMenu('safeweb')}>
                      <NavLink
                        to="/mdm/safeweb-preferences"
                        className="nav-link hoverly"
                      >
                        <i className="far fa-circle nav-icon" />
                        <p className="colorLeters">Preferencias</p>
                      </NavLink>
                    </li>}
              </ul>
            </li> */}
            <li className="nav-item">
              <NavLink
                to="/"
                className="nav-link hoverly"
                onClick={() => sessionStorage.clear()}
              >
                <i className="fa fa-arrow-left nav-icon" aria-hidden="true"></i>
                <p className="colorLeters">{t('salida')}</p>
              </NavLink>
            </li>
          </ul>
        </nav>
      </div>
      <p className="version">{t('version')}</p>
    </aside>
  )
}
